import styled from '@emotion/styled'
import { Tooltip } from 'components/Tooltip'
import { BREAKPOINTS } from 'utils/styled'

export const SWizardContentHeading = styled.div`
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 0.5rem;
  }
`

export const SWizardContentHeadingTitle = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
`

export const SWizardContentHeadingTooltipWrapper = styled.div`
  transform: translate(0);
  position: relative;
  display: flex;
  align-items: center;
`

export const SWizardContentHeadingTooltip = styled(Tooltip)`
  width: max-content;
  max-width: min(80vw, 25rem);
  text-align: start;
  font-weight: normal;
  font-size: 1rem;
  line-height: 1.75rem;
`

export const SWizardContent = styled.div`
  max-width: 100%;
  flex-grow: 1;

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 3rem;
  }
`

export const SWizardContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 7px;

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 5vw;
    margin-bottom: 2vw;
  }
`

export const SWizardContentBack = styled.div`
  display: inline-flex;
  height: 24px;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--c-blue500);
`
